import { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { logout } from "../actions"

const LOGIN_URL = "/login"

export default function LogoutScreen() {
  const history = useHistory()

  useEffect(() => {
    logout()
      .then(() => history.push(LOGIN_URL))
      .catch(err => {
        console.log("error when logging out:", err)
        history.push(LOGIN_URL)
      })
  }, [])

  return null
}
